var _g, _g2, _g3, _g4, _g5, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareCardBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 191,
    viewBox: "0 0 192 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140 10C145.523 10 150 14.4766 150 20C150 24.9922 146.344 29.1289 141.563 29.8789V22.8906H143.893L144.336 20H141.563V18.125C141.563 17.334 141.949 16.5625 143.191 16.5625H144.453V14.1016C144.453 14.1016 143.309 13.9062 142.215 13.9062C139.93 13.9062 138.438 15.291 138.438 17.7969V20H135.898V22.8906H138.438V29.8789C133.656 29.1289 130 24.9922 130 20C130 14.4766 134.477 10 140 10Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.329 32C118.252 32 119 32.7475 119 33.6708V50.3292C119 51.252 118.252 52 117.329 52H100.671C99.748 52 99 51.2525 99 50.3292V33.6708C99 32.748 99.7475 32 100.671 32H117.329ZM112.519 39.5C111.099 39.5 110.128 40.1274 109.696 40.8563L109.625 40.9858V39.625H106.917V49.2083H109.833V44.5663C109.833 43.0104 110.406 42.0208 111.783 42.0208C112.733 42.0208 113.132 42.8607 113.164 44.358L113.167 44.5663V49.2083H116.083V43.9154C116.083 41.0575 115.4 39.5 112.519 39.5ZM104.833 39.5H101.917V49.0833H104.833V39.5ZM103.375 34.5C102.34 34.5 101.5 35.3396 101.5 36.375C101.5 37.4104 102.34 38.25 103.375 38.25C104.41 38.25 105.25 37.4104 105.25 36.375C105.25 35.3396 104.41 34.5 103.375 34.5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179 73.9373C178.265 74.2655 177.474 74.4882 176.644 74.5882C177.491 74.0764 178.141 73.2673 178.447 72.3027C177.655 72.7755 176.776 73.1191 175.842 73.3045C175.094 72.5018 174.027 72 172.847 72C170.581 72 168.744 73.85 168.744 76.1309C168.744 76.4545 168.78 76.77 168.85 77.0727C165.44 76.9 162.416 75.2555 160.393 72.7564C160.039 73.3664 159.836 74.0764 159.836 74.8327C159.836 76.2664 160.561 77.5309 161.662 78.2718C160.99 78.25 160.357 78.0645 159.804 77.7545C159.804 77.7718 159.804 77.7891 159.804 77.8073C159.804 79.8082 161.217 81.4782 163.095 81.8573C162.75 81.9518 162.388 82.0027 162.014 82.0027C161.749 82.0027 161.493 81.9764 161.242 81.9282C161.764 83.5691 163.279 84.7636 165.075 84.7973C163.671 85.9055 161.901 86.5655 159.979 86.5655C159.647 86.5655 159.321 86.5464 159 86.5082C160.815 87.68 162.973 88.3636 165.29 88.3636C172.837 88.3636 176.965 82.0691 176.965 76.61C176.965 76.4309 176.96 76.2527 176.953 76.0755C177.755 75.4936 178.45 74.7655 179 73.9373Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.107 35.5539C170.272 35.2269 170.612 35 171 35H187C187.388 35 187.728 35.2269 187.893 35.554L179 41.7793L170.107 35.5539ZM170 37.9206V48C170 48.5477 170.452 49 171 49H187C187.548 49 188 48.5477 188 48V37.9207L179.574 43.8192C179.229 44.0603 178.771 44.0603 178.427 43.8192L170 37.9206ZM190 36.0177V48C190 49.6523 188.652 51 187 51H171C169.348 51 168 49.6523 168 48V36C168 34.3477 169.348 33 171 33H187C188.644 33 189.987 34.3347 190 35.976C190 35.9899 190 36.0038 190 36.0177Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134 68C132.895 68 132 68.8954 132 70C132 71.1046 132.895 72 134 72C135.105 72 136 71.1046 136 70C136 68.8954 135.105 68 134 68ZM130 70C130 67.7909 131.791 66 134 66C136.209 66 138 67.7909 138 70C138 72.2091 136.209 74 134 74C131.791 74 130 72.2091 130 70Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122 75C120.895 75 120 75.8954 120 77C120 78.1046 120.895 79 122 79C123.105 79 124 78.1046 124 77C124 75.8954 123.105 75 122 75ZM118 77C118 74.7909 119.791 73 122 73C124.209 73 126 74.7909 126 77C126 79.2091 124.209 81 122 81C119.791 81 118 79.2091 118 77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134 82C132.895 82 132 82.8954 132 84C132 85.1046 132.895 86 134 86C135.105 86 136 85.1046 136 84C136 82.8954 135.105 82 134 82ZM130 84C130 81.7909 131.791 80 134 80C136.209 80 138 81.7909 138 84C138 86.2091 136.209 88 134 88C131.791 88 130 86.2091 130 84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.133 78.3605C124.411 77.8834 125.023 77.7219 125.5 78L131.5 81.5C131.977 81.7781 132.139 82.3903 131.861 82.8675C131.582 83.3447 130.97 83.5061 130.493 83.228L124.493 79.728C124.016 79.45 123.854 78.8377 124.133 78.3605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.86 71.1323C132.138 71.6093 131.977 72.2216 131.5 72.5L125.508 76.2274C125.031 76.5057 124.419 76.3447 124.14 75.8677C123.862 75.3907 124.023 74.7784 124.5 74.5L130.492 70.7726C130.969 70.4943 131.581 70.6553 131.86 71.1323Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 146,
    cy: 45,
    r: 145,
    fill: "#4B48C1",
    fillOpacity: 0.3,
    stroke: "white",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 146,
    cy: 44.9999,
    r: 69.6196,
    fill: "#4B48C1",
    fillOpacity: 0.4,
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareCardBg);
export default __webpack_public_path__ + "static/media/share_card_bg.ad2252fb2b1a9612174588d851b6b3af.svg";
export { ForwardRef as ReactComponent };